import { DEFAULT_LABEL_SIZE } from "./sizes";
import type { LabelBuildOptions, LabelSizeId, PassportLabelData } from "../types";
import { renderZplTemplate } from "./renderTemplate";
import template76x51 from "./templates/passport-76x51.zpl?raw";
import template100x50 from "./templates/passport-100x50.zpl?raw";
import template102x76 from "./templates/passport-102x76.zpl?raw";
import template56x25 from "./templates/passport-56x25.zpl?raw";

export const PASSPORT_TEMPLATE_SIZES: readonly LabelSizeId[] = ["76x51", "56x25", "100x50", "102x76"] as const;

/** Placeholders used by passport-<size>.zpl — keep in sync with the template file. */
export const PASSPORT_PLACEHOLDERS = [
  "qrValue",
  "certifiedHeading",
  "title",
  "modelLine",
  "categoryLine",
  "completedLine",
  "qualityGradeLine",
  "serialNumberHeading",
  "serialNumber",
  "scanHint",
] as const;

const TEMPLATES: Partial<Record<LabelSizeId, string>> = {
  "76x51": template76x51,
  "100x50": template100x50,
  "102x76": template102x76,
  "56x25": template56x25,
};

export function renderPassportZpl(
  data: PassportLabelData,
  size: LabelSizeId = DEFAULT_LABEL_SIZE,
  options: LabelBuildOptions = {},
): string {
  const template = options.zplTemplate ?? TEMPLATES[size] ?? TEMPLATES[DEFAULT_LABEL_SIZE]!;
  return renderZplTemplate(
    template,
    {
      qrValue: data.qrValue,
      certifiedHeading: data.certifiedHeading,
      title: data.title,
      modelLine: data.modelLine,
      categoryLine: data.categoryLine,
      completedLine: data.completedLine,
      qualityGradeLine: data.qualityGradeLine ?? "",
      serialNumberHeading: data.serialNumberHeading,
      serialNumber: data.serialNumber,
      scanHint: data.scanHint,
    },
    { allowedPlaceholders: PASSPORT_PLACEHOLDERS },
  );
}
